import React from 'react'
import "./Home.css"
import raspberrypi from "../../assets/raspberrypi.png"
import wifimodule from "../../assets/module.webp"


import {Swiper,SwiperSlide} from "swiper/react"
import {Navigation,Pagination,Autoplay,EffectFade} from 'swiper/modules'

import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import 'swiper/css/effect-fade'

import slide1 from "../../assets/iotimage.jpg"
import slide2 from "../../assets/Ai.jpg"
import slide3 from "../../assets/automationimage.jpg"

const Home = () => { 

  return (
    
        <>
        <div className='overall'>
         <Swiper 
           onSlideChange={(swiper)=>{
          const slides=document.querySelectorAll(".s1")
          slides.forEach((slide,index)=>{
           if(index === swiper.activeIndex){
            slide.classList.add('active')
           }
           else{
            slide.classList.remove("active")
           }
          })
        }}
       
        className='swiper-container'
        modules={[Navigation,Pagination,Autoplay,EffectFade]}
        effect="fade"
        spaceBetween={50}//space between slides
        slidesPerView={1}//no of slides visible
        navigation // enable navigation arrow
        pagination={{clickable:true}} //enable clickable pagination
        autoplay={{delay:5000}} //auto slide every 3 seconds
        loop// enable infinite loop 
        >
        <SwiperSlide>
          <div className='s1'>
              <div className='text1'>
                <h1 >Innovation starts with a connection—welcome to the IoT era</h1>
              </div>
            <img src={slide1} alt="" />
          </div>
        </SwiperSlide>
        
        <SwiperSlide>
          <div className='s1'>
          <div className='text2'>
             <h1 > Turning data into intelligence, one algorithm at a time.</h1>
          </div>
            <img src={slide2} alt="" />
          </div>
        </SwiperSlide>
        
        <SwiperSlide>
          <div className='s1'>
            <div className='text3'>
              <h1>Work smarter, not harder embrace automation</h1>
            </div>
            <img src={slide3} alt=""  />
          </div>
        </SwiperSlide>
       </Swiper>
  
  
  
  
  <div className='wholebg' data-aos="fade-left" data-aos-duration="1000">
   <div className='firstcard' >
    <div className='content-image'>
     <img src={raspberrypi} alt="" data-aos="fade-up" />
     <div className='content'>
      
      <div className='c1main'>
         <h1>Using raspberry pi modules</h1>
         <p>Raspberry Pi opens up a world of possibilities for developers, hobbyists, 
           and students to innovate and create impactful projects.With its versatility, you can use it in fields like 
           IoT, automation, AI, robotics, and more</p>
      </div>
      
       <div className='c1'>
          <h1>Energy Monitoring System</h1>
          <p>Monitor energy consumption in your home or office using smart meters and sensors. Raspberry Pi can log data, visualize trends, and help optimize energy usage</p>
       </div>
       
       <div className='c1'>
         <h1>Digital Signage System</h1>
         <p>Create an interactive display board for advertisements, announcements, or event schedules. Raspberry Pi can handle multimedia content and be integrated with touchscreens.</p>
       </div>
      </div>
     </div>
    </div>   
   </div>
   
   
   {/*cards2*/}
     <div className='wholebg' data-aos="zoom-in-up">
         <div className='secondcard'>
           <div className='content2_image'>
           <div className='c2main'>
                 <h1>Using ESP32/ESP8266 modules</h1>
                 <p>Welcome to the future of IoT, automation, and AI, powered by ESP32 and ESP8266—versatile and powerful microcontrollers designed to make your projects smarter and more connected. With built-in Wi-Fi, Bluetooth, and a plethora of GPIOs, 
                  these modules unlock endless possibilities for creating intelligent devices and systems</p>
              </div>
              <div className='c2'>
                 <h1>Home Automation</h1>
                 <p>Control lights, fans, and appliances remotely
                   Automate your home with voice assistants like Alexa or Google Assistant.
                   Build a smart door lock for enhanced security.</p>
              </div>
              <div className='c3'>
                   <h1>Environmental Monitoring</h1>
                      <p>
                       Set up a weather station to measure temperature, humidity, and air quality.
                       Monitor soil moisture and optimize irrigation for your garden.
                       Track water quality with pH and turbidity sensors.
                       </p>
              </div>
              </div>
              <img src={wifimodule} alt="" data-aos="fade-left" />
         </div>
     </div>


{/*cards infinity 
     <div className='projectcards'>
          <div className='card1'>
              <p>Mechanical</p>
          </div>
          <div className='card1'>
            <p> Electrical & electronics</p>
          </div>
          <div className='card1'>
              <p>Civil</p>
          </div>
          <div className='card1'>
             <p>web development</p> 
          </div>
          <div className='card1'>
             <p>Software</p> 
          </div>
          <div className='card1'>
             <p>Artificial intelligence</p> 
          </div>
     </div>*/}
  </div>
  </>
  )
}

export default Home